export const ADDED_FLOOR = "ADDED_FLOOR";
export const addedFloor = (data) => ({
  type: ADDED_FLOOR,
  payload: data,
});
